export default __webpack_public_path__ + "img/startimes.9d194f85.png";